import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "grid grid-cols-6 pt-3 border-t gap-3" }
const _hoisted_4 = { class: "flex flex-col mb-3 col-span-3" }
const _hoisted_5 = { class: "flex flex-col mb-3 col-span-3" }
const _hoisted_6 = { class: "flex flex-col grow" }
const _hoisted_7 = {
  key: 0,
  class: "grid grid-cols-1 gap-3"
}
const _hoisted_8 = {
  key: 1,
  class: "grid grid-cols-1 gap-3"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex flex-col lg:col-span-6" }
const _hoisted_11 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_12 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_13 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_14 = { class: "flex justify-end pt-3" }
const _hoisted_15 = { class: "m-auto px-5 pb-32" }
const _hoisted_16 = { class: "m-auto" }
const _hoisted_17 = { class: "pt-3 sticky top-0.5 z-10" }
const _hoisted_18 = { class: "py-5 flex justify-between items-center" }
const _hoisted_19 = { class: "flex gap-3" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = { class: "whitespace-nowrap" }
const _hoisted_22 = { class: "whitespace-nowrap" }
const _hoisted_23 = { class: "bg-next-gray-md-dark text-sm py-1 px-2 flex items-center whitespace-nowrap" }
const _hoisted_24 = { class: "flex justify-between items-end" }
const _hoisted_25 = { class: "text-3xl font-bold" }
const _hoisted_26 = { class: "pl-4" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "text-sm" }
const _hoisted_29 = { class: "mb-5" }
const _hoisted_30 = { class: "font-bold" }
const _hoisted_31 = { class: "font-bold" }
const _hoisted_32 = { class: "flex items-center justify-between" }
const _hoisted_33 = {
  key: 0,
  class: "overflow-x-scroll"
}
const _hoisted_34 = { class: "flex items-center" }
const _hoisted_35 = ["value", "onInput"]
const _hoisted_36 = {
  key: 0,
  class: "h-full w-full"
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AzioniSottoProgetto = _resolveComponent("AzioniSottoProgetto")!
  const _component_ModalFeesDetail = _resolveComponent("ModalFeesDetail")!
  const _component_ModalCaricaExcel = _resolveComponent("ModalCaricaExcel")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_SelectStato = _resolveComponent("SelectStato")!
  const _component_SottoProgettoHead = _resolveComponent("SottoProgettoHead")!
  const _component_ToolbarSottoProgetto = _resolveComponent("ToolbarSottoProgetto")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_DynamicCell = _resolveComponent("DynamicCell")!
  const _component_OffertaContextMenu = _resolveComponent("OffertaContextMenu")!
  const _component_NextSottoProgettoTable = _resolveComponent("NextSottoProgettoTable")!
  const _component_SezioneSottoProgetti = _resolveComponent("SezioneSottoProgetti")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_AzioniSottoProgetto, {
        id: _ctx.id,
        visible: _ctx.azioni_visible,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.azioni_visible) = $event)),
        tabindex: _ctx.tabindex,
        "onUpdate:tabindex": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tabindex) = $event)),
        sottoprogetto: _ctx.sottoprogetto_model.titolo,
        cliente_id: _ctx.sottoprogetto_model.cliente_id,
        fee: _ctx.dati.fee,
        sections: _ctx.ActiveTab.sezioni,
        rebate: _ctx.dati.rebate,
        "onUpdate:rebate": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dati.rebate) = $event)),
        valute: _ctx.dati.valute,
        default_markup: _ctx.dati.default_markup,
        "onUpdate:default_markup": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dati.default_markup) = $event)),
        "onUpdate:valute": _ctx.onUpdateValute,
        "onUpdate:fee": _ctx.onUpdateFees,
        onApplica_mark_up_a_tutti: _ctx.onApplicaMarkUpATutti,
        nota: _ctx.nota,
        "onUpdate:nota": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.nota) = $event)),
        tags: _ctx.tags,
        "onUpdate:tags": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tags) = $event)),
        infoPolicy: _ctx.infoPolicy,
        "onUpdate:infoPolicy": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.infoPolicy) = $event)),
        dataOfferta: _ctx.dataOfferta,
        "onUpdate:dataOfferta": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dataOfferta) = $event)),
        terminiPagamento: _ctx.terminiPagamento,
        "onUpdate:terminiPagamento": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.terminiPagamento) = $event)),
        sconto: _ctx.sconto,
        "onUpdate:sconto": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.sconto) = $event)),
        onSaved: _ctx.onChangeSottoProgetto,
        onCopiaStoricoVendite: _ctx.onCambiaStoricoVendite,
        onSavePreference: _cache[10] || (_cache[10] = ($event: any) => (_ctx.syncUserPreference(_ctx.tableHeader))),
        onManualSave: _ctx.versionamentoManuale,
        onSavePolicy: _ctx.savePolicy,
        onSaveSconto: _ctx.saveSconto,
        onImport: _ctx.importSottoprogetto,
        waiting: _ctx.waiting,
        "onUpdate:waiting": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.waiting) = $event))
      }, null, 8, ["id", "visible", "tabindex", "sottoprogetto", "cliente_id", "fee", "sections", "rebate", "valute", "default_markup", "onUpdate:valute", "onUpdate:fee", "onApplica_mark_up_a_tutti", "nota", "tags", "infoPolicy", "dataOfferta", "terminiPagamento", "sconto", "onSaved", "onCopiaStoricoVendite", "onManualSave", "onSavePolicy", "onSaveSconto", "onImport", "waiting"]),
      _createVNode(_component_ModalFeesDetail, {
        visible: _ctx.show_fee_detail,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.show_fee_detail) = $event))
      }, null, 8, ["visible"]),
      _createVNode(_component_ModalCaricaExcel, {
        onSuccess: _ctx.reloadExcelImport,
        sottoprogetto_id: _ctx.id,
        backdrop: true,
        visible: _ctx.show_carica_excel,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.show_carica_excel) = $event))
      }, null, 8, ["onSuccess", "sottoprogetto_id", "visible"]),
      _createVNode(_component_Modal, {
        visible: _ctx.modal_allegato_stato,
        "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.modal_allegato_stato) = $event)),
        backdrop: ""
      }, {
        header: _withCtx(() => _cache[32] || (_cache[32] = [
          _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "text-lg font-bold mb-3" }, "Richiesta apertura progetto")
          ], -1)
        ])),
        main: _withCtx(() => [
          _cache[38] || (_cache[38] = _createElementVNode("p", { class: "" }, "Stai per richiedere l'apertura della commessa, allega un file di conferma del cliente (email, contratto, etc).", -1)),
          _createElementVNode("p", _hoisted_1, [
            _cache[33] || (_cache[33] = _createTextVNode("Con la richiesta di apertura stai confermando il preventivo ")),
            _createElementVNode("span", _hoisted_2, "\"" + _toDisplayString(_ctx.ActiveTab.titolo) + "\"", 1),
            _cache[34] || (_cache[34] = _createTextVNode(", assicurati che sia quello corretto prima di procedere."))
          ]),
          _cache[39] || (_cache[39] = _createElementVNode("p", { class: "mb-3" }, "Oppure nel caso di \"Accordo quadro\" puoi procedere senza allegare alcun file", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Field, { field_name: "Accordo quadro" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Checkbox, {
                    checked: _ctx.accordo_quadro,
                    onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.accordo_quadro = !_ctx.accordo_quadro)),
                    checkClass: "w-4 h-4"
                  }, {
                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                      _createTextVNode(" Accordo quadro ")
                    ])),
                    _: 1
                  }, 8, ["checked"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Field, {
                labelVisible: false,
                errors: _ctx.modal_stato_errors['file_id']
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FileUpload, {
                    uploaded_files: _ctx.uploaded_files,
                    "onUpdate:uploaded_files": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.uploaded_files) = $event)),
                    model_files: _ctx.model_files,
                    "onUpdate:model_files": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.model_files) = $event)),
                    to_delete: _ctx.to_delete,
                    "onUpdate:to_delete": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.to_delete) = $event)),
                    accept: ".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                  }, {
                    default: _withCtx(({ props, methods }) => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_NextButton, {
                          variant: "outline-secondary",
                          onClick: methods.open,
                          class: "w-full h-10 px-4 grow"
                        }, {
                          default: _withCtx(() => _cache[36] || (_cache[36] = [
                            _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1),
                            _createTextVNode(" Allega ")
                          ])),
                          _: 2
                        }, 1032, ["onClick"]),
                        (props.to_upload)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.to_upload, (f, idx) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  class: "underline text-sm text-next-atp pt-3",
                                  key: idx
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(f.name), 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.uploaded_files)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploaded_files, (f, idx) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  class: "underline text-sm text-next-atp pt-3 cursor-pointer",
                                  onClick: ($event: any) => (_ctx.downloadFile(f?.id)),
                                  key: idx
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(f.name), 1)
                                ], 8, _hoisted_9))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalFileError(props.errors), (e, i) => {
                          return (_openBlock(), _createElementBlock("small", {
                            key: i,
                            class: "text-next-orange"
                          }, _toDisplayString(e), 1))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["uploaded_files", "model_files", "to_delete"])
                ]),
                _: 1
              }, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Field, {
                field_name: "Descrizione",
                modelValue: _ctx.modal_stato.descrizione,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.modal_stato.descrizione) = $event)),
                errors: _ctx.modal_stato_errors['descrizione'],
                placeholder: "Descrizione"
              }, null, 8, ["modelValue", "errors"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Field, {
                field_name: "Paese",
                required: false,
                errors: _ctx.modal_stato_errors['paese_id'],
                placeholder: "Paese"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VueMultiselect, {
                    modelValue: _ctx.paeseAutocomplete.selection,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.paeseAutocomplete.selection) = $event)),
                    options: _ctx.paeseAutocomplete.options,
                    onSearchChange: _ctx.paeseAutocomplete.search,
                    "close-on-select": true,
                    "clear-on-select": true,
                    placeholder: "Paese",
                    deselectLabel: "Deseleziona",
                    selectedLabel: "Selezionato",
                    selectLabel: "Seleziona",
                    class: "next-vue-multiselect-single",
                    "track-by": "id",
                    label: "nome"
                  }, {
                    noResult: _withCtx(() => _cache[37] || (_cache[37] = [
                      _createTextVNode("Nessun elemento trovato.")
                    ])),
                    _: 1
                  }, 8, ["modelValue", "options", "onSearchChange"])
                ]),
                _: 1
              }, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Field, {
                field_name: "Numero Pax",
                required: false,
                errors: _ctx.modal_stato_errors['numero_pax'],
                modelValue: _ctx.modal_stato.numero_pax,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.modal_stato.numero_pax) = $event))
              }, null, 8, ["errors", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Field, {
                field_name: "Città",
                required: false,
                modelValue: _ctx.modal_stato.citta,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modal_stato.citta) = $event)),
                type: "text",
                errors: _ctx.modal_stato_errors['citta'],
                placeholder: "Città"
              }, null, 8, ["modelValue", "errors"])
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_NextButton, {
              variant: "outline-secondary",
              onClick: _cache[22] || (_cache[22] = ($event: any) => {this.uploaded_files.splice(0); _ctx.modal_allegato_stato = false}),
              class: "col-start-3 py-2 px-4"
            }, {
              default: _withCtx(() => _cache[40] || (_cache[40] = [
                _createTextVNode(" Chiudi ")
              ])),
              _: 1
            }),
            _createVNode(_component_NextButton, {
              variant: "primary",
              onClick: _ctx.performCambioStatoWithFile,
              disabled: _ctx.loading_cambio_stato,
              class: "ml-4 py-2 px-4 flex items-center justify-center"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_Spinner, { class: "w-4 h-4 mr-4" }, null, 512), [
                  [_vShow, _ctx.loading_cambio_stato]
                ]),
                _cache[41] || (_cache[41] = _createTextVNode(" Richiedi Apertura "))
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])),
    _cache[50] || (_cache[50] = _createElementVNode("div", { id: "cmModal" }, null, -1)),
    _cache[51] || (_cache[51] = _createElementVNode("div", { id: "selectModal" }, null, -1)),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("div", _hoisted_17, [
          _createVNode(_component_Alert, { class: "bg-next-orange" }, {
            default: _withCtx(() => _cache[42] || (_cache[42] = [
              _createTextVNode("Ci sono diverse valute di vendita nel budget")
            ])),
            _: 1
          })
        ], 512), [
          [_vShow, !_ctx.StessaValutaVendita]
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.getBreadcrumbsPath }, null, 8, ["paths"]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("span", _hoisted_21, "Accordo quadro", 512), [
                [_vShow, _ctx.sottoprogetto_model.accordo_quadro]
              ]),
              _withDirectives(_createElementVNode("span", _hoisted_22, " / ", 512), [
                [_vShow, _ctx.sottoprogetto_model.accordo_quadro && _ctx.allegato_sottoprogetto]
              ]),
              (_ctx.allegato_sottoprogetto)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "underline text-sm text-next-atp whitespace-nowrap cursor-pointer",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.downloadFile(_ctx.allegato_sottoprogetto?.id)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.allegato_sottoprogetto?.name), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_SelectStato, {
              "sottoprogetto-id": _ctx.id,
              onSelect: _ctx.changeSottoprogettoStato,
              modelValue: _ctx.sottoprogetto_model.stato
            }, null, 8, ["sottoprogetto-id", "onSelect", "modelValue"]),
            _createElementVNode("div", _hoisted_23, " Versione " + _toDisplayString(_ctx.sottoprogetto_model.last_major) + "." + _toDisplayString(_ctx.sottoprogetto_model.last_minor) + " del " + _toDisplayString(_ctx.$filters.toDate(_ctx.sottoprogetto_model.updated_at)) + " alle " + _toDisplayString(_ctx.$filters.toTime(_ctx.sottoprogetto_model.updated_at)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.sottoprogetto_model.titolo), 1),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("div", _hoisted_27, _cache[43] || (_cache[43] = [
              _createElementVNode("svg", {
                role: "status",
                class: "w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-next-orange",
                viewBox: "0 0 100 101",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                  fill: "currentColor"
                }),
                _createElementVNode("path", {
                  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                  fill: "currentFill"
                })
              ], -1),
              _createElementVNode("span", null, "Salvataggio in corso...", -1)
            ]), 512), [
              [_vShow, _ctx.salvataggio_pendente]
            ]),
            _withDirectives(_createElementVNode("span", { class: "text-next-orange" }, "Errore durante il salvataggio: " + _toDisplayString(_ctx.errore_salvataggio), 513), [
              [_vShow, _ctx.errore_salvataggio]
            ])
          ]),
          _createElementVNode("div", _hoisted_28, "ID progetto: " + _toDisplayString(_ctx.progetto_model?.id_gamma) + " / Codice commessa: " + _toDisplayString(_ctx.sottoprogetto_model?.cod_nodo), 1)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("small", null, [
            _cache[44] || (_cache[44] = _createTextVNode("da ")),
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.sottoprogetto_model.data_inizio ? _ctx.$filters.toDate(_ctx.sottoprogetto_model.data_inizio) : '-'), 1),
            _cache[45] || (_cache[45] = _createTextVNode(" a ")),
            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.sottoprogetto_model.data_fine ? _ctx.$filters.toDate(_ctx.sottoprogetto_model.data_fine) : '-'), 1)
          ])
        ]),
        _createVNode(_component_SottoProgettoHead, {
          class: "mb-5",
          onClickFee: _cache[25] || (_cache[25] = ($event: any) => (_ctx.show_fee_detail = true)),
          budget: _ctx.sottoprogetto_model.budget ? `${_ctx.$filters.toEuroCurrency(Number(_ctx.sottoprogetto_model.budget))}` : '-',
          budgetProgetto: _ctx.ActiveTab && _ctx.TotaleBudgetProgettoConFee(_ctx.ActiveTab.sezioni) ? `${_ctx.$filters.toEuroCurrency(_ctx.TotaleBudgetProgettoConFee(_ctx.ActiveTab.sezioni))} (${_ctx.$filters.toEuroCurrency(_ctx.TotaleBudgetProgetto(_ctx.ActiveTab.sezioni))})` : '-',
          totaleRicavi: _ctx.ActiveTab && _ctx.TotaleRicaviProgetto(_ctx.ActiveTab.sezioni) ? `${_ctx.$filters.toEuroCurrency(_ctx.TotaleRicaviProgettoConFee(_ctx.ActiveTab.sezioni))} (${_ctx.$filters.toEuroCurrency(_ctx.TotaleRicaviProgetto(_ctx.ActiveTab.sezioni))})` : '-',
          commissioni: _ctx.ActiveTab && _ctx.TotaleCommissioniProgetto(_ctx.ActiveTab.sezioni) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleCommissioniProgetto(_ctx.ActiveTab.sezioni)) : '-',
          totaleCosti: _ctx.ActiveTab && _ctx.TotaleCostiEuroProgetto(_ctx.ActiveTab.sezioni) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleCostiEuroProgetto(_ctx.ActiveTab.sezioni)) : '-',
          utile: _ctx.ActiveTab && _ctx.TotaleUtiliProgetto(_ctx.ActiveTab.sezioni) ? `${_ctx.$filters.toEuroCurrency(_ctx.TotaleUtiliProgettoConFee(_ctx.ActiveTab.sezioni))} (${_ctx.$filters.toEuroCurrency(_ctx.TotaleUtiliProgetto(_ctx.ActiveTab.sezioni))})` : '-',
          margine: _ctx.ActiveTab && _ctx.TotaleMolProgetto(_ctx.ActiveTab.sezioni) ? `${_ctx.TotaleMolProgettoConFee(_ctx.ActiveTab.sezioni).toLocaleValueString(2, 2)} % (${_ctx.TotaleMolProgetto(_ctx.ActiveTab.sezioni).toLocaleValueString(2, 2)} %)` : '-',
          secondoMargine: _ctx.ActiveTab && `${_ctx.$filters.toEuroCurrency(_ctx.TotaleUtiliProgettoConFee(_ctx.ActiveTab.sezioni) - _ctx.TotaleCostoRisorseProgetto(_ctx.ActiveTab.sezioni))}`,
          totaleRisorse: _ctx.ActiveTab && _ctx.TotaleCostoRisorseProgetto(_ctx.ActiveTab.sezioni) ? `${_ctx.$filters.toEuroCurrency(_ctx.TotaleCostoRisorseProgetto(_ctx.ActiveTab.sezioni))}` : '-',
          fee: _ctx.ActiveTab && _ctx.TotaleFeesSezioni(_ctx.ActiveTab.sezioni) ? _ctx.TotaleFeesSezioni(_ctx.ActiveTab.sezioni).toLocaleValueString(2, 2) : '-'
        }, null, 8, ["budget", "budgetProgetto", "totaleRicavi", "commissioni", "totaleCosti", "utile", "margine", "secondoMargine", "totaleRisorse", "fee"]),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_ToolbarSottoProgetto, {
            id: _ctx.id,
            visible: _ctx.azioni_visible,
            "onUpdate:visible": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.azioni_visible) = $event)),
            onToggleExpand: _ctx.preventSaveOnToggleExpand,
            "onUpdate:tabindex": _ctx.openToolbar
          }, null, 8, ["id", "visible", "onToggleExpand", "onUpdate:tabindex"]),
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.show_carica_excel = true)),
            class: "p-1 flex items-center justify-center"
          }, {
            default: _withCtx(() => _cache[46] || (_cache[46] = [
              _createTextVNode(" Carica Excel ")
            ])),
            _: 1
          })
        ]),
        _createVNode(_component_Tabs, {
          class: "py-5",
          onAddtab: _ctx.addTab,
          onRemovetab: _ctx.removeTab,
          onDuplicatab: _ctx.duplicaTab,
          tabs: _ctx.dati.tabs,
          disabled: (_ctx.sottoprogetto_model?.stato?.PD1E_CODICE !== _ctx.StatiSottoprogetto.OFFERTA && _ctx.sottoprogetto_model?.stato?.PD1E_CODICE !== _ctx.StatiSottoprogetto.OFFERTA_INVIATA),
          modelValue: _ctx.dati.active_tab,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.dati.active_tab) = $event)),
          allowDelete: _ctx.dati.tabs.length > 1,
          onEditingChange: _ctx.onTabEditing
        }, null, 8, ["onAddtab", "onRemovetab", "onDuplicatab", "tabs", "disabled", "modelValue", "allowDelete", "onEditingChange"]),
        (_ctx.ActiveTab)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ActiveTab.sezioni, (s, i) => {
                return (_openBlock(), _createBlock(_component_SezioneSottoProgetti, {
                  titolo: s.titolo,
                  "onUpdate:titolo": ($event: any) => ((s.titolo) = $event),
                  key: s.titolo + i,
                  deletable: _ctx.ActiveTab.sezioni.length > 1,
                  order: i + 1,
                  last: i === _ctx.ActiveTab.sezioni.length - 1,
                  first: i === 0,
                  expanded: s.expanded,
                  "onUpdate:expanded": ($event: any) => (_ctx.preventSaveOnToggleExpand(s)),
                  onClickAddRow: ($event: any) => (_ctx.addRowSezione(s)),
                  onOrderUp: ($event: any) => (_ctx.handleOrderUp(_ctx.ActiveTab.sezioni, i)),
                  onOrderDown: ($event: any) => (_ctx.handleOrderDown(_ctx.ActiveTab.sezioni, i)),
                  onCancella: ($event: any) => (_ctx.cancellaSezione(i)),
                  onClickAggiungiSezione: ($event: any) => (_ctx.aggiungiSezione(i)),
                  onClickDuplicaSezione: ($event: any) => (_ctx.duplicaSezione(i)),
                  totaleCosti: _ctx.TotaleCostiEuroSezione(s) ? `${_ctx.$filters.toEuroCurrency(_ctx.TotaleCostiEuroSezione(s))}` : '-',
                  budgetProgetto: _ctx.TotaleBudgetProgettoSezione(s) ? `${_ctx.$filters.toEuroCurrency(_ctx.TotaleBudgetProgettoSezione(s))}` : '-',
                  fee: _ctx.TotaleFeesSezione(s) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleFeesSezione(s)) : '-',
                  primoMarigne: _ctx.TotaleUtileEuroSezione(s) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleUtileEuroSezione(s)) : '-',
                  primoMarignePerc: _ctx.TotaleMolSezione(s) ? `${_ctx.TotaleMolSezione(s).toLocaleValueString(2, 2)} %` : '-'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_NextSottoProgettoTable, {
                      class: "w-full border-separate",
                      actionClass: "hidden",
                      nuvola_td_class: "border-next-nuvola",
                      alternativa_td_class: "border-next-alternativa",
                      opzionale_td_class: "border-next-opzionale",
                      cols: _ctx.tableHeader,
                      "onUpdate:cols": _ctx.syncUserPreference,
                      rows: s.ordered_records,
                      "onUpdate:rows": ($event: any) => (_ctx.onUpdateRows(s, $event)),
                      onOrderUpdate: _ctx.performOrder
                    }, _createSlots({ _: 2 }, [
                      _renderList(_ctx.rowCellIterator(s.ordered_records, _ctx.sottoProgettiCols), (rc, x) => {
                        return {
                          name: `td_${rc}`,
                          fn: _withCtx(({ row, cell }) => [
                            _createVNode(_component_DynamicCell, _mergeProps({
                              is_component: _ctx.getComponent(row, cell),
                              onInput: ($event: any) => (_ctx.setValue(row, cell, $event.target.value)),
                              value: _ctx.getValue(row, cell),
                              ref_for: true
                            }, _ctx.getProps(row, cell), { class: "h-6" }), null, 16, ["is_component", "onInput", "value"])
                          ])
                        }
                      }),
                      _renderList(s.ordered_records, (c, j) => {
                        return {
                          name: `td_${j}_preactions`,
                          fn: _withCtx((context) => [
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(_component_OffertaContextMenu, {
                                menuClass: "shadow absolute flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white",
                                context: c,
                                id: `i${i}_j${j}_${context.row.length}`,
                                teleport_to: "#cmModal",
                                cmOpener: _ctx.cmOpener,
                                onAddNuvola: ($event: any) => (_ctx.addNuvola(c)),
                                onToggleDescrizione: ($event: any) => (_ctx.toggleDescrizione(c)),
                                onToggleOpzionale: ($event: any) => (_ctx.toggleOpzionale(c)),
                                onAddAlternativa: ($event: any) => (_ctx.addAlternativa(c)),
                                onCancella: ($event: any) => (_ctx.cancellaRecord(s, c)),
                                onEliminaSottoriga: ($event: any) => (_ctx.eliminaSottoriga(s, c)),
                                onPromuovi: ($event: any) => (_ctx.promuoviSottoriga(s, c)),
                                onDuplicaRecord: ($event: any) => (_ctx.duplicaRecord(s, c)),
                                onDuplicaSottoRecord: ($event: any) => (_ctx.duplicaSottoriga(s, c))
                              }, null, 8, ["context", "id", "cmOpener", "onAddNuvola", "onToggleDescrizione", "onToggleOpzionale", "onAddAlternativa", "onCancella", "onEliminaSottoriga", "onPromuovi", "onDuplicaRecord", "onDuplicaSottoRecord"]),
                              _createVNode(_component_Checkbox, {
                                disabled: !c._nuvola,
                                checkClass: "ml-3 block h-4 w-4",
                                checked: _ctx.getValue(c, { prop: 'show_in_export' }),
                                onChange: ($event: any) => (_ctx.setValue(c, { prop: 'show_in_export' }, !_ctx.getValue(c, { prop: 'show_in_export' })))
                              }, null, 8, ["disabled", "checked", "onChange"])
                            ])
                          ])
                        }
                      }),
                      _renderList(s.ordered_records, (c, j) => {
                        return {
                          name: `td_${j}_ne_descrizione_servizio`,
                          fn: _withCtx(({ row, cell }) => [
                            _createVNode(_component_DynamicCell, _mergeProps({
                              modelValue: _ctx.getValue(row, cell),
                              is_component: _ctx.getComponent(row, cell),
                              ref_for: true
                            }, _ctx.getProps(row, cell), {
                              onConfirm: ($event: any) => (_ctx.setValue(row, cell, $event)),
                              class: "next-vue-multiselect-single overflow-ellipsis",
                              titolo: "Descrizione"
                            }), {
                              cell: _withCtx((option) => [
                                _createTextVNode(_toDisplayString(_ctx.getValue(row, cell)), 1)
                              ]),
                              main: _withCtx((option) => [
                                _createElementVNode("textarea", {
                                  class: "border mb-3 border-next-dark-gray",
                                  rows: "6",
                                  value: _ctx.getValue(row, cell),
                                  onInput: ($event: any) => (option.setInternalValue($event.target.value))
                                }, "                                        ", 40, _hoisted_35)
                              ]),
                              _: 2
                            }, 1040, ["modelValue", "is_component", "onConfirm"])
                          ])
                        }
                      }),
                      _renderList(s.ordered_records, (c, j) => {
                        return {
                          name: `td_${j}_ne_fornitore`,
                          fn: _withCtx(({ row, cell }) => [
                            _createVNode(_component_DynamicCell, _mergeProps({
                              modelValue: _ctx.getValue(row, cell),
                              is_component: _ctx.getComponent(row, cell),
                              ref_for: true
                            }, _ctx.getProps(row, cell), {
                              onConfirm: ($event: any) => (_ctx.setValue(row, cell, $event)),
                              class: "next-vue-multiselect-single overflow-ellipsis",
                              autocomplete: _ctx.fornitoreAutocomplete,
                              "track-by": "id",
                              label: "denominazione",
                              placeholder: "Fornitore",
                              titolo: "Fornitore"
                            }), {
                              main: _withCtx((option) => [
                                _createVNode(_component_VueMultiselect, {
                                  options: _ctx.fornitoreAutocomplete.options,
                                  modelValue: _ctx.fornitoreAutocomplete.selection,
                                  "onUpdate:modelValue": [
                                    _cache[29] || (_cache[29] = ($event: any) => ((_ctx.fornitoreAutocomplete.selection) = $event)),
                                    ($event: any) => (option.setInternalValue($event))
                                  ],
                                  loading: _ctx.fornitoreAutocomplete.isLoading,
                                  onSearchChange: _ctx.fornitoreAutocomplete.search,
                                  class: "next-vue-multiselect-single overflow-ellipsis mb-3",
                                  "close-on-select": true,
                                  "clear-on-select": false,
                                  deselectLabel: "Deseleziona",
                                  selectedLabel: "Selezionato",
                                  selectLabel: "Seleziona",
                                  "track-by": "id",
                                  label: "denominazione",
                                  placeholder: "Fornitore",
                                  titolo: "Fornitore"
                                }, {
                                  noResult: _withCtx(() => _cache[47] || (_cache[47] = [
                                    _createTextVNode("Nessun elemento trovato.")
                                  ])),
                                  singleLabel: _withCtx(({ option }) => [
                                    _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                                  ]),
                                  option: _withCtx(({ option }) => [
                                    _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["options", "modelValue", "loading", "onUpdate:modelValue", "onSearchChange"])
                              ]),
                              _: 2
                            }, 1040, ["modelValue", "is_component", "onConfirm", "autocomplete"])
                          ])
                        }
                      }),
                      _renderList(s.ordered_records, (c, j) => {
                        return {
                          name: `td_${j}_ne_stato`,
                          fn: _withCtx(({ row, cell }) => [
                            _createVNode(_component_DynamicCell, _mergeProps({
                              modelValue: _ctx.getValue(row, cell),
                              is_component: _ctx.getComponent(row, cell),
                              ref_for: true
                            }, _ctx.getProps(row, cell), { titolo: "Stato" }), {
                              cell: _withCtx(({ value }) => [
                                value
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass(["h-full w-full font-bold", _ctx.getStatoOffertaColor(row)])
                                    }, _toDisplayString(value?.descrizione), 3))
                                  : _createCommentVNode("", true)
                              ]),
                              main: _withCtx(() => [
                                _createVNode(_component_VueMultiselect, {
                                  modelValue: _ctx.getValue(row, cell),
                                  "onUpdate:modelValue": ($event: any) => (_ctx.setValue(row, cell, $event)),
                                  options: _ctx.StatiOfferta,
                                  "close-on-select": true,
                                  "clear-on-select": false,
                                  placeholder: "Stato",
                                  class: "mb-3 next-vue-multiselect-single",
                                  deselectLabel: "Deseleziona",
                                  selectedLabel: "Selezionato",
                                  selectLabel: "Seleziona",
                                  "track-by": "id",
                                  label: "descrizione"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                              ]),
                              _: 2
                            }, 1040, ["modelValue", "is_component"])
                          ])
                        }
                      }),
                      _renderList(s.ordered_records, (c, j) => {
                        return {
                          name: `td_${j}_ne_tipologia`,
                          fn: _withCtx(({ row, cell }) => [
                            _createVNode(_component_DynamicCell, _mergeProps({
                              modelValue: _ctx.getValue(row, cell),
                              is_component: _ctx.getComponent(row, cell),
                              ref_for: true
                            }, _ctx.getProps(row, cell), { titolo: "Tipologia" }), {
                              cell: _withCtx(({ value }) => [
                                value
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(value?.descrizione), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              main: _withCtx(() => [
                                _createVNode(_component_VueMultiselect, {
                                  modelValue: _ctx.getValue(row, cell),
                                  "onUpdate:modelValue": ($event: any) => (_ctx.setValue(row, cell, $event)),
                                  options: _ctx.Tipologia,
                                  "close-on-select": true,
                                  "clear-on-select": false,
                                  placeholder: "Tipologia",
                                  class: "mb-3 next-vue-multiselect-single",
                                  deselectLabel: "Deseleziona",
                                  selectedLabel: "Selezionato",
                                  selectLabel: "Seleziona",
                                  "track-by": "id",
                                  label: "descrizione"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                              ]),
                              _: 2
                            }, 1040, ["modelValue", "is_component"])
                          ])
                        }
                      }),
                      _renderList(s.ordered_records, (c, j) => {
                        return {
                          name: `td_${j}_ne_voce_spesa`,
                          fn: _withCtx(({ row, cell }) => [
                            _createVNode(_component_DynamicCell, _mergeProps({
                              modelValue: _ctx.getValue(row, cell),
                              is_component: _ctx.getComponent(row, cell),
                              ref_for: true
                            }, _ctx.getProps(row, cell), {
                              onConfirm: ($event: any) => (_ctx.setValue(row, cell, $event)),
                              autocomplete: _ctx.vocespesaAutocomplete,
                              class: "next-vue-multiselect-single",
                              placeholder: "Voce di spesa",
                              titolo: "Voce di spesa",
                              "track-by": "id",
                              label: "descrizione"
                            }), null, 16, ["modelValue", "is_component", "onConfirm", "autocomplete"])
                          ])
                        }
                      }),
                      _renderList(s.ordered_records, (c, j) => {
                        return {
                          name: `td_${j}_ac_valuta`,
                          fn: _withCtx(({ row, cell }) => [
                            _createVNode(_component_DynamicCell, _mergeProps({
                              modelValue: _ctx.getValue(row, cell),
                              is_component: _ctx.getComponent(row, cell),
                              ref_for: true
                            }, _ctx.getProps(row, cell), {
                              onConfirm: ($event: any) => (_ctx.setValue(row, cell, $event)),
                              autocomplete: _ctx.customValutaAutocomplete,
                              titolo: "Valuta di acquisto"
                            }), {
                              cell: _withCtx(({ value }) => [
                                value
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(`${value.descrizione} - 1 ${value.valuta?.CG08_SIGLA} =
                                                ${value.valore} €`), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              main: _withCtx((option) => [
                                _createVNode(_component_VueMultiselect, {
                                  options: _ctx.customValutaAutocomplete.options,
                                  modelValue: _ctx.customValutaAutocomplete.selection,
                                  "onUpdate:modelValue": [
                                    _cache[30] || (_cache[30] = ($event: any) => ((_ctx.customValutaAutocomplete.selection) = $event)),
                                    ($event: any) => (option.setInternalValue($event))
                                  ],
                                  loading: _ctx.customValutaAutocomplete.isLoading,
                                  onSearchChange: _ctx.customValutaAutocomplete.search,
                                  class: "next-vue-multiselect-single overflow-ellipsis mb-3",
                                  "close-on-select": true,
                                  "clear-on-select": false,
                                  deselectLabel: "Deseleziona",
                                  selectedLabel: "Selezionato",
                                  selectLabel: "Seleziona",
                                  "track-by": "id",
                                  placeholder: "Valuta di acquisto"
                                }, {
                                  noResult: _withCtx(() => _cache[48] || (_cache[48] = [
                                    _createTextVNode("Nessun elemento trovato.")
                                  ])),
                                  singleLabel: _withCtx(({ option }) => [
                                    _createTextVNode(_toDisplayString(`${option.descrizione} - 1 ${option.valuta?.CG08_SIGLA} =
                                                ${option.valore} €`), 1)
                                  ]),
                                  option: _withCtx(({ option }) => [
                                    _createTextVNode(_toDisplayString(`${option.descrizione} - 1 ${option.valuta?.CG08_SIGLA} =
                                                ${option.valore} €`), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["options", "modelValue", "loading", "onUpdate:modelValue", "onSearchChange"])
                              ]),
                              _: 2
                            }, 1040, ["modelValue", "is_component", "onConfirm", "autocomplete"])
                          ])
                        }
                      }),
                      _renderList(s.ordered_records, (c, j) => {
                        return {
                          name: `td_${j}_ac_aliquota`,
                          fn: _withCtx(({ row, cell }) => [
                            _createVNode(_component_DynamicCell, _mergeProps({
                              modelValue: _ctx.getValue(row, cell),
                              is_component: _ctx.getComponent(row, cell),
                              ref_for: true
                            }, _ctx.getProps(row, cell), {
                              onConfirm: ($event: any) => (_ctx.setValue(row, cell, $event)),
                              autocomplete: _ctx.aliquotaAutocomplete,
                              class: "next-vue-multiselect-single",
                              placeholder: "Aliquota",
                              titolo: "Aliquota",
                              "track-by": "id",
                              label: "descrizione"
                            }), null, 16, ["modelValue", "is_component", "onConfirm", "autocomplete"])
                          ])
                        }
                      }),
                      _renderList(s.ordered_records, (c, j) => {
                        return {
                          name: `td_${j}_ve_valuta`,
                          fn: _withCtx(({ row, cell }) => [
                            _createVNode(_component_DynamicCell, _mergeProps({
                              modelValue: _ctx.getValue(row, cell),
                              is_component: _ctx.getComponent(row, cell),
                              autocomplete: _ctx.customValutaAutocomplete,
                              ref_for: true
                            }, _ctx.getProps(row, cell), {
                              onConfirm: ($event: any) => (_ctx.setValue(row, cell, $event)),
                              titolo: "Valuta di vendita"
                            }), {
                              cell: _withCtx(({ value }) => [
                                value
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(`${value.descrizione} - 1 ${value.valuta?.CG08_SIGLA} =
                                                ${value.valore} €`), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              main: _withCtx((option) => [
                                _createVNode(_component_VueMultiselect, {
                                  options: _ctx.customValutaAutocomplete.options,
                                  modelValue: _ctx.customValutaAutocomplete.selection,
                                  "onUpdate:modelValue": [
                                    _cache[31] || (_cache[31] = ($event: any) => ((_ctx.customValutaAutocomplete.selection) = $event)),
                                    ($event: any) => (option.setInternalValue($event))
                                  ],
                                  loading: _ctx.customValutaAutocomplete.isLoading,
                                  onSearchChange: _ctx.customValutaAutocomplete.search,
                                  class: "next-vue-multiselect-single overflow-ellipsis mb-3",
                                  "close-on-select": true,
                                  "clear-on-select": false,
                                  deselectLabel: "Deseleziona",
                                  selectedLabel: "Selezionato",
                                  selectLabel: "Seleziona",
                                  "track-by": "id",
                                  placeholder: "Valuta di vendita"
                                }, {
                                  noResult: _withCtx(() => _cache[49] || (_cache[49] = [
                                    _createTextVNode("Nessun elemento trovato.")
                                  ])),
                                  singleLabel: _withCtx(({ option }) => [
                                    _createTextVNode(_toDisplayString(`${option.descrizione} - 1 ${option.valuta?.CG08_SIGLA} =
                                                ${option.valore} €`), 1)
                                  ]),
                                  option: _withCtx(({ option }) => [
                                    _createTextVNode(_toDisplayString(`${option.descrizione} - 1 ${option.valuta?.CG08_SIGLA} =
                                                ${option.valore} €`), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["options", "modelValue", "loading", "onUpdate:modelValue", "onSearchChange"])
                              ]),
                              _: 2
                            }, 1040, ["modelValue", "is_component", "autocomplete", "onConfirm"])
                          ])
                        }
                      }),
                      _renderList(s.ordered_records, (c, j) => {
                        return {
                          name: `td_${j}_ve_aliquota`,
                          fn: _withCtx(({ row, cell }) => [
                            _createVNode(_component_DynamicCell, _mergeProps({
                              modelValue: _ctx.getValue(row, cell),
                              is_component: _ctx.getComponent(row, cell),
                              ref_for: true
                            }, _ctx.getProps(row, cell), {
                              onConfirm: ($event: any) => (_ctx.setValue(row, cell, $event)),
                              autocomplete: _ctx.aliquotaAutocomplete,
                              class: "next-vue-multiselect-single",
                              placeholder: "Aliquota",
                              titolo: "Aliquota di vendita",
                              "track-by": "id",
                              label: "descrizione"
                            }), null, 16, ["modelValue", "is_component", "onConfirm", "autocomplete"])
                          ])
                        }
                      }),
                      _renderList(s.ordered_records, (c, j) => {
                        return {
                          name: `td_${j}_ve_fee`,
                          fn: _withCtx(({ row, cell }) => [
                            _createVNode(_component_DynamicCell, _mergeProps({
                              modelValue: _ctx.getValue(row, cell),
                              is_component: _ctx.getComponent(row, cell),
                              ref_for: true
                            }, _ctx.getProps(row, cell), { titolo: "Fee" }), {
                              cell: _withCtx(({ value }) => [
                                value
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(`${value?.descrizione} - ${value?.valore}%`), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              main: _withCtx(() => [
                                _createVNode(_component_VueMultiselect, {
                                  modelValue: _ctx.getValue(row, cell),
                                  "onUpdate:modelValue": ($event: any) => (_ctx.setValue(row, cell, $event)),
                                  options: _ctx.dati.fee,
                                  "close-on-select": true,
                                  "clear-on-select": false,
                                  placeholder: "Fee",
                                  class: "mb-3 next-vue-multiselect-single",
                                  deselectLabel: "Deseleziona",
                                  selectedLabel: "Selezionato",
                                  selectLabel: "Seleziona",
                                  "track-by": "id",
                                  label: "descrizione"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                              ]),
                              _: 2
                            }, 1040, ["modelValue", "is_component"])
                          ])
                        }
                      })
                    ]), 1032, ["cols", "onUpdate:cols", "rows", "onUpdate:rows", "onOrderUpdate"])
                  ]),
                  _: 2
                }, 1032, ["titolo", "onUpdate:titolo", "deletable", "order", "last", "first", "expanded", "onUpdate:expanded", "onClickAddRow", "onOrderUp", "onOrderDown", "onCancella", "onClickAggiungiSezione", "onClickDuplicaSezione", "totaleCosti", "budgetProgetto", "fee", "primoMarigne", "primoMarignePerc"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}